import React, { Component } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { VoaDetailList, VoaItemTable } from "../components";
import * as voa from "../redux";

export class VoaDetail extends Component {
    componentDidMount() {
        const { voaID, getDetail } = this.props;
        getDetail(voaID);
    }

    render() {
        const { voa, loading, extraProps } = this.props;
        const base_op = {
            className: "voa_list",
            breadcrumbs: [
                { name: "Home", rel: "/", icon: "home" },
                { name: "VOA Management", rel: "/voa/" },
                { name: `VOA ${voa ? voa.voa_number : ""}` }
            ],
            extraProps,
            loading
        };

        return (
            <Base {...base_op}>
                <VoaDetailList voa={voa} />
                <VoaItemTable items={voa ? voa.items : []} />
            </Base>
        );
    }
}

const mapStateToProps = (store, ownProps) => {
    return {
        voa: store.voa.voa,
        voaID: ownProps.match.params.voaID,
        loading: store.voa.loading,
        loaded: store.voa.loaded
    };
};

const mapDispatchToProps = dispatch => ({
    getDetail: voa_id => dispatch(voa.actions.getVoaDetail(voa_id))
});

export default connect(mapStateToProps, mapDispatchToProps)(VoaDetail);
